module.exports = __webpack_public_path__ + "img/crosswalk.62e2fd4d.jpg";